/* eslint-disable */
import React, { forwardRef, useMemo, memo } from 'react';
import './MustSeeSpots.css';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IMAGE_DIR_PATH, PUBLIC_CMS_URL } from '../../../APIs/endpoint';
import MustSeeSpotsSkeleton from '../../Loader/MustSeeSpotsSkeleton';
import CustomButton from '../../Common/button';
// import { getUrlAfterDomain } from '../../../helper/global';
//import { convertToHyphenatedLowerCase, GetZoneUsingState } from '../../../helper/global';

// eslint-disable-next-line react/display-name
const SpotCard = memo(({ item, onClick }) => (
  <Box className="spot-card" onClick={onClick}>
    <img
      loading="lazy"
      srcSet={`
        ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.INDIA_MUST_SEE_PATH}${item.indiamustsee_image}?w=300 300w,
        ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.INDIA_MUST_SEE_PATH}${item.indiamustsee_image}?w=768 768w,
        ${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.INDIA_MUST_SEE_PATH}${item.indiamustsee_image}?w=1024 1024w
      `}
      sizes="(max-width: 600px) 300px, (max-width: 1024px) 768px, 1024px"
      src={`${PUBLIC_CMS_URL}${IMAGE_DIR_PATH.INDIA_MUST_SEE_PATH}${item.indiamustsee_image}`}
      alt={item.indiamustsee_destination}
      className="spot-image"
    />
    <Typography className="spot-explore">Explore</Typography>
    <Typography className="spot-name">{item.indiamustsee_destination}</Typography>
  </Box>
));

const MustSeeSpots = forwardRef(({ mustSeeData }, ref) => {
  const navigate = useNavigate();
  const sortedMustSeeData = useMemo(
    () => mustSeeData?.sort((a, b) => a.indiamustsee_sequence_no - b.indiamustsee_sequence_no),
    [mustSeeData]
  );

  //TODO: enable below fucntion in create dynamic url
  // const handleImageClick = useCallback(
  //   (destination) => {
  //     const zone = GetZoneUsingState(destination);
  //     const url = zone
  //       ? `/explore/india/${zone}/${convertToHyphenatedLowerCase(destination)}`
  //       : '/explore/india';
  //     navigate(url);
  //   },
  //   [navigate]
  // );

  // const handleImageClick = (url) => {
  //   const resultUrl = url ? getUrlAfterDomain(url) : '/explore/india';
  //   navigate(resultUrl);
  // };

  return (
    <Box className="must-see-spots-container" ref={ref}>
      {/* <Box className="must-see-spots-details">
        <Typography className="must-see-sport-title" gutterBottom>
          India’s Must-See Spots
        </Typography>
        <Typography className="subtitle">
          Iconic landmarks to hidden gems, these locations offer unforgettable adventures and
          stunning sights.
        </Typography>
      </Box> */}

      {!sortedMustSeeData || sortedMustSeeData.length === 0 ? (
        <MustSeeSpotsSkeleton />
      ) : (
        <Box className="must-see-spots-grid">
          {/* {sortedMustSeeData.map((item, index) => (
            <SpotCard
              key={index}
              item={item}
              onClick={() => handleImageClick(item.indiamustsee_url)}
            />
          ))} */}
        </Box>
      )}
      {/* <Box className="button-container">
        <CustomButton title="Book Now" onClick={() => navigate('/explore')} />
      </Box> */}
    </Box>
  );
});

MustSeeSpots.displayName = 'MustSeeSpots';

export default MustSeeSpots;
